import { Box, Typography, Paper } from '@mui/material';
import DamageReportTable from './DamageReportTable';
import ConditionInstancesTable from './ConditionInstancesTable';
import MissingProducts from './MissingProducts';
import DoubleBookedInstancesTable from './DoubleBookedInstancesTable';

const styles = {
  productsBlock: {
    marginTop: '20px',
  },
  title: (theme) => ({
    fontSize: '25px',
    color: '#555555',
    lineHeight: '92px',

    [theme.breakpoints.down('md')]: {
      paddingLeft: '10px',
      paddingRight: '10px',
      fontSize: '16px',
      textTransform: 'uppercase',
      letterSpacing: '0.9px',
      fontWeight: 200,
    },
  }),
  transportsGrid: (theme) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '28px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      gap: '16px',
    },
  }),
  gridElem: (theme) => ({
    width: '100%',
    padding: '12px 24px',

    [theme.breakpoints.down('md')]: {
      borderRadius: 0,
    },
  }),
  gridElemTitleBlock: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '5px',
  },
  gridElemTitle: {
    fontSize: '18px',
    lineHeight: '38px',
    color: 'black',
    fontWeight: 500,
  },
  btnLabel: {
    textTransform: 'none',
    color: '#da4453',
  },
  periodText: {
    paddingBottom: '4px',
    fontSize: '10px',
    lineHeight: '10px',
    color: 'gray',
  },
};

const ProductsBlock = () => {
  return (
    <Box sx={styles.productsBlock}>
      <Typography sx={styles.title}>Products</Typography>
      <Box sx={styles.transportsGrid}>
        <Paper sx={styles.gridElem}>
          <Box sx={styles.gridElemTitleBlock}>
            <Typography sx={styles.gridElemTitle}>Missing products</Typography>
          </Box>
          <Typography sx={styles.periodText}>Last 7 days</Typography>
          <MissingProducts />
        </Paper>
        <Paper sx={styles.gridElem}>
          <Box sx={styles.gridElemTitleBlock}>
            <Typography sx={[styles.gridElemTitle, { marginBottom: '14px' }]}>
              Damage reports
            </Typography>
          </Box>
          <DamageReportTable />
        </Paper>
        <Paper sx={styles.gridElem}>
          <Box sx={styles.gridElemTitleBlock}>
            <Typography sx={styles.gridElemTitle}>Condition</Typography>
          </Box>
          <Typography sx={styles.periodText}>Last 30 days</Typography>
          <ConditionInstancesTable />
        </Paper>
        <Paper sx={styles.gridElem}>
          <Box sx={styles.gridElemTitleBlock}>
            <Typography sx={styles.gridElemTitle}>
              Double booked instances
            </Typography>
          </Box>
          <Typography sx={styles.periodText}>Next 21 days</Typography>
          <DoubleBookedInstancesTable />
        </Paper>
      </Box>
    </Box>
  );
};
export default ProductsBlock;
